import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useWebARApp } from "../../contexts/WebARAppContext.jsx";

const MapCanvas = ({ pins, onPinClicked }) => {
  const { canvasMap2d, showMap } = useWebARApp();

  useEffect(() => {
    if (canvasMap2d) {
      canvasMap2d.classList.remove("hidden");
      // const container = document.querySelector(".canvasMap2d");
      // if (container && !container.contains(canvasMap2d)) {
      //   container.appendChild(canvasMap2d); // Add canvas to DOM
      // }

      // Call showMap, passing pins and onPinClicked props
      showMap(pins, onPinClicked);
    }

    return () => {
      canvasMap2d.classList.add("hidden");
    };
  }, [canvasMap2d, showMap, pins, onPinClicked]);

  // return <div id="pixi-container" style={{ width: "100%", height: "100%" }} />;
  return <></>;
};

MapCanvas.propTypes = {
  pins: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      status: PropTypes.string.isRequired,
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
      ar: PropTypes.bool.isRequired,
      visited: PropTypes.bool.isRequired,
    })
  ).isRequired,
  onPinClicked: PropTypes.func.isRequired,
};

export default MapCanvas;
